import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import LanguageTabs from '../../Tabs/LanguageTabs';
import LanguageTab from '../../Tabs/LanguageTab';
import FormInput from '../../Form/FormInput';
import FormTextarea from '../../Form/FormTextarea';

import imageModifier from '../../../utils/imageModifier';
import SingleObjUploaderWithSelector from '../Mam/SingleObjUploaderWithSelector';
import Modal from '../../Modal/Modal';

const languages = ['EN', 'ES', 'CA', 'PT'];

class ArtistLanguageTabsContainer extends Component {
  state = {
    isModalOn: false,
    currImageLang: '',
  };

  componentDidMount() {
    const { sendTabsInfo, getTabsInfo } = this.props;

    languages.map(lang => this.setState({ [`artistSetReadableName${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('artistSetReadableName') && sendTabsInfo.artistSetReadableName !== null && sendTabsInfo.artistSetReadableName[lang.toLowerCase()]) || '' }));

    languages.map(lang => this.setState({ [`shortTitle${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('shortTitle') && sendTabsInfo.shortTitle !== null && sendTabsInfo.shortTitle[lang.toLowerCase()]) || '' }));

    languages.map(lang => this.setState({ [`smallText${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('smallText') && sendTabsInfo.smallText !== null && sendTabsInfo.smallText[lang.toLowerCase()]) || '' }, () => getTabsInfo(this.state)));

    languages.map(lang => this.setState({ [`imageObj${lang}`]: (sendTabsInfo && sendTabsInfo.hasOwnProperty('image') && sendTabsInfo.image !== null && sendTabsInfo.image[lang.toLowerCase()]) || '' }));
  }

  storeText = (lang, value) => {
    const { getTabsInfo } = this.props;
    this.setState(
      {
        [lang]: value,
      },
      () => {
        getTabsInfo(this.state);
      },
    );
  };


  setImage = ([obj]) => {
    const { currImageLang } = this.state;
    const { getTabsInfo } = this.props;
    this.toggleModal();
    this.setState({ [`imageObj${currImageLang}`]: obj.url }, () => {
      getTabsInfo(this.state);
    });
  };

  toggleModal = (lang) => {
    this.setState({
      isModalOn: !this.state.isModalOn,
      currImageLang: lang,
    });
  };

  render() {
    const { sendTabsInfo, action } = this.props;
    const { isModalOn } = this.state;
    return (
      <div className="bg-black text-white mt-4 language-tabs ">
        <LanguageTabs>
          {languages.map(lang => (
            <LanguageTab label={lang} key={lang}>
              <div className="bg-greyWithinForm pt-1 pb-px px-8 rounded">
                <FormInput name={`artistSetReadableName${lang}`} title="Artist Set Readable Name" value={(this.state[`artistSetReadableName${lang}`] && this.state[`artistSetReadableName${lang}`]) || ''} storeText={this.storeText} action={action} />
                <FormInput name={`shortTitle${lang}`} title="Short Title" value={(this.state[`shortTitle${lang}`] && this.state[`shortTitle${lang}`]) || ''} storeText={this.storeText} action={action} />
                {/* <FormInput name={`image${lang}`} title="Image" value={(this.state[`image${lang}`] && this.state[`image${lang}`]) || ''} storeText={this.storeText} action={action} /> */}
                {/* required={lang === 'EN' ? true : !this.state.artistSetReadableNameEN} */}
                <FormTextarea name={`smallText${lang}`} title="Small Text" value={(this.state[`smallText${lang}`] && this.state[`smallText${lang}`]) || ''} storeText={this.storeText} action={action} />
              </div>
              <div className="image pl-8 mb-7">{this.state && this.state[`imageObj${lang}`] && <img src={imageModifier(this.state && this.state[`imageObj${lang}`], '100x100')} alt="artistSet-Image" className="rounded" />}</div>
              <div className="bg-greyFilter pb-2 pt-1 pl-8 rounded-br-lg rounded-bl-xl">
                <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase bg-black text-white flex flex-row items-center" type="button" onClick={() => this.toggleModal(lang)} disabled={action === 'display' || action === 'delete'}>
                  {this.state && this.state[`imageObj${lang}`] ? 'Change image' : 'Select image'}
                  {this.state && this.state[`imageObj${lang}`] ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-white" /> : <span className="font-icon icon-add-button text-base text-white font-bold pl-2" />}
                </button>
              </div>
            </LanguageTab>
          ))}
        </LanguageTabs>
        {isModalOn && (
          <Modal handleClick={this.toggleModal} positionMiddle zIndex="5" singleUploader>
            <SingleObjUploaderWithSelector selectCallback={this.setImage} />
          </Modal>
        )}
      </div>
    );
  }
}

ArtistLanguageTabsContainer.propTypes = {
  getTabsInfo: PropTypes.func.isRequired,
  sendTabsInfo: PropTypes.shape(),
  action: PropTypes.string.isRequired,
};

ArtistLanguageTabsContainer.defaultProps = {
  sendTabsInfo: {},
};

export default ArtistLanguageTabsContainer;
